const IconX = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M3.31819 2.68185C3.14245 2.50611 2.85753 2.50611 2.68179 2.68185C2.50605 2.85759 2.50605 3.14251 2.68179 3.31825L5.36359 6.00005L2.68179 8.68185C2.50605 8.85759 2.50605 9.14251 2.68179 9.31825C2.85753 9.49398 3.14245 9.49398 3.31819 9.31825L5.99999 6.63644L8.62149 9.25794C8.79722 9.43368 9.08215 9.43368 9.25788 9.25794C9.43362 9.08221 9.43362 8.79728 9.25788 8.62155L6.63638 6.00005L9.25788 3.37855C9.43362 3.20281 9.43362 2.91789 9.25788 2.74215C9.08215 2.56642 8.79722 2.56642 8.62149 2.74215L5.99999 5.36365L3.31819 2.68185Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default IconX;
